import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandleDots2Icon } from '@radix-ui/react-icons';
import SongTile from './SongTile';

/**
 * SortableSongTile Component
 * Wraps SongTile with @dnd-kit sortable functionality and a custom drag handle overlay.
 */
const SortableSongTile = ({ song, onEdit, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: song.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 'auto',
  };

  // This handler starts the drag and stops it from bubbling to parent gestures/swiper
  const handlePointerDown = (e) => {
    listeners.onPointerDown(e);
    e.stopPropagation();
  };

  return (
    // Main container moved by dnd-kit
    <div ref={setNodeRef} style={style} {...attributes} className="relative">
      
      {/* Standard SongTile: hover scaling is disabled while actively dragging */}
      <SongTile 
        song={song}
        showEdit 
        onEdit={onEdit}
        onClick={onClick}
        isInteractive={!isDragging}
      />

      {/* Drag handle overlay */}
      <div 
        onPointerDown={handlePointerDown}
        onKeyDown={listeners.onKeyDown} // For accessibility
        className="absolute top-2 left-2 p-1 cursor-grab active:cursor-grabbing text-white bg-black/30 rounded-full touch-none"
        tabIndex={0}
      >
        <DragHandleDots2Icon width={20} height={20} />
      </div>

    </div>
  );
};

export default SortableSongTile;